export { SpacedGroup } from './spaced-group';
export type { SpacedGroupProps } from './spaced-group';
